import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogTitle, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
/**
 * * Reusable confirmation dialog component with confirm and cancel button actions
 *
 * @param props
 */
export const ConfirmationDialog = ({ isOpen, dialogTitle, cancelButtonText, confirmButtonText, onCancelButtonClick, onConfirmButtonClick, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsxs(Dialog, Object.assign({ open: isOpen }, { children: [_jsx(DialogTitle, { children: _jsx(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: _jsx(Typography, Object.assign({ variant: "h3", color: "secondary" }, { children: dialogTitle })) })) }), _jsxs(DialogActions, Object.assign({ disableSpacing: true, sx: {
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: "space-between",
                    gap: isMobile ? 2 : 4,
                } }, { children: [_jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "outlined", color: "secondary", onClick: onCancelButtonClick }, { children: cancelButtonText })), _jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "contained", color: "secondary", onClick: onConfirmButtonClick }, { children: confirmButtonText }))] }))] })));
};
